import { combineReducers } from 'redux';
import { createBrowserHistory } from 'history';
import { configureStore } from '@reduxjs/toolkit';
import { dialogReducer } from 'stores/dialogSlice';
import { deviceReducer } from 'stores/deviceSlice';
import { errorReducer } from 'stores/errorSlice';
import { createSentryReduxEnhancer } from 'stores/enhancer';

export const history = createBrowserHistory();

const reducer = combineReducers({
  dialogState: dialogReducer,
  deviceState: deviceReducer,
  errorState: errorReducer,
});

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['dialog/showDialog', 'error/setExceptionError'],
      },
    }),
  enhancers: (getDefaultEnhancers) =>
    getDefaultEnhancers().concat(createSentryReduxEnhancer()),
  devTools: process.env.NODE_ENV !== 'production',
});
